import { render, staticRenderFns } from "./EducationTests.vue?vue&type=template&id=4ebb3c6d&"
import script from "./EducationTests.vue?vue&type=script&lang=js&"
export * from "./EducationTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports